<template>
  <div
    :key="rerenderKey"
    style="
      position: absolute;
      cursor: move;
    "
    :style="{
      'background-color': (settings.color ? settings.color : 'black'),
      top: `${settings.yPos}px`,
      left: `${settings.xPos}px`,
      width: `${settings.width}px`,
      height: `${settings.height}px`,
      'z-index': isDragging ? 901 : 900,
    }"
    @mousedown.stop="onDragMouse"
    @touchstart.stop="onDragTouch"
    @mouseup="onDropMouse"
    @touchend="onDropTouch"
    @mousemove="onMoveMouse"
    @touchmove="onMoveTouch"
  >
    <!-- {{ settings }} -->
    <div
      v-if="isDragging"
      style="
        position: absolute;
        top: -5000px;
        left: -5000px;
        width: 10000px;
        height: 10000px;
      "
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    /** expects `xPos`, `yPos`, `width`, `height`, `color` */
    settings: { type: Object },
    lockX: { type: Boolean },
    lockY: { type: Boolean },
    scaleFactor: { type: Number },
  },
  data() {
    return {
      dragOffsetX: 0,
      dragOffsetY: 0,
      isDragging: false,
      rerenderKey: 0,
    };
  },
  methods: {
    onDragMouse(ev) {
      console.log('grabbed');
      this.isDragging = true;
      this.dragOffsetX = (ev.screenX / this.scaleFactor) - +this.settings.xPos;
      this.dragOffsetY = (ev.screenY / this.scaleFactor) - +this.settings.yPos;
      this.$emit('drag-start', this.settings);
    },
    onDragTouch(ev) {
      ev.stopPropagation();
      if (ev.touches.length !== 1) return;
      this.isDragging = true;
      this.dragOffsetX = (ev.touches[0].screenX / this.scaleFactor) - +this.settings.xPos;
      this.dragOffsetY = (ev.touches[0].screenY / this.scaleFactor) - +this.settings.yPos;
      this.$emit('drag-start', this.settings);
    },
    onDrop() {
      console.log('dropped');
      this.isDragging = false;
      this.dragOffsetX = 0;
      this.dragOffsetY = 0;
      this.$emit('drag-end', this.settings);
    },
    onDropMouse() {
      this.onDrop();
    },
    onDropTouch() {
      this.onDrop();
    },
    onMoveMouse(ev) {
      if (this.isDragging) {
        console.log('moved');
        console.log(this.scaleFactor);
        if (!(this.lockX)) {
          this.settings.xPos = Math.round((ev.screenX / this.scaleFactor) - this.dragOffsetX);
        }
        if (!(this.lockY)) {
          this.settings.yPos = Math.round((ev.screenY / this.scaleFactor) - this.dragOffsetY);
        }
        this.$emit('drag-move', this.settings);
        this.rerenderKey = (this.rerenderKey + 1) % 100;
      }
    },
    onMoveTouch(ev) {
      if (this.isDragging) {
        ev.stopPropagation();
        if (ev.touches.length !== 1) return;
        if (!(this.lockX)) {
          this.settings.xPos = Math.round((ev.touches[0].screenX / this.scaleFactor) - this.dragOffsetX);
        }
        if (!(this.lockY)) {
          this.settings.yPos = Math.round((ev.touches[0].screenY / this.scaleFactor) - this.dragOffsetY);
        }
        this.$emit('drag-move', this.settings);
        this.rerenderKey = (this.rerenderKey + 1) % 100;
      }
    },
  },
  watch: {
    settings: {
      handler() {
        this.rerenderKey = (this.rerenderKey + 1) % 100;
      },
      deep: true
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/ui/DraggableDiv.vue